import React, { useState } from 'react';

import InfoContainer from '../components/InfoContainer';


const ContactMe = () => {
    const [active, setActive] = useState(false);
    const handleButton = () => {
        setActive(!active);
    }
    return (
        <InfoContainer>
            <div className={'info-container'}>
                <div className="contact-area">
                    <div className="contact">
                        <main>
                            <section>
                                <div className="content">
                                    <img src={'images/avatar/avatar.png'} alt={'Profile'}/>

                                    <aside>
                                        <h1>Gihan Tharanga</h1>
                                        <p>I'm always looking for new challenges and new people to meet. Don’thesitate to contact me.</p>
                                    </aside>

                                    <button className={`${active && 'active'}`} onClick={() => handleButton()}>
                                        <span>Contact Me</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                                            <g className="nc-icon-wrapper" fill="#444444"> <path d="M14.83 30.83L24 21.66l9.17 9.17L36 28 24 16 12 28z"></path> </g> </svg>
                                    </button>
                                </div>
                            </section>


                        </main>

                        <nav className={`${active && 'active'}`}>
                            <a href={'mailto:companysketch740@gmail.com'} className={'gmail'} style={{ textAlign: 'left' }}>
                                <div className="icon">
                                    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M16 3v10c0 .567-.433 1-1 1h-1V4.925L8 9.233 2 4.925V14H1c-.567 0-1-.433-1-1V3c0-.283.108-.533.287-.712C.467 2.107.718 2 1 2h.333L8 6.833 14.667 2H15c.283 0 .533.108.713.288.179.179.287.429.287.712z" fill-rule="evenodd" /></svg>
                                </div>

                                <div className="content">
                                    <h1>Email</h1>
                                    <span>companysketch740@gmail.com</span>
                                </div>

                                <svg className="arrow" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"> <g className="nc-icon-wrapper" fill="#444444"> <path d="M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z"></path> </g> </svg>
                            </a>

                            <a href={'https://www.facebook.com/GihanTharangaBandara/'} target={'_blank'} rel="noreferrer" className={'facebook'} style={{ textAlign: 'left' }}>
                                <div className="icon">
                                    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M15.117 0H.883C.395 0 0 .395 0 .883v14.234c0 .488.395.883.883.883h7.663V9.804H6.46V7.39h2.086V5.607c0-2.066 1.262-3.19 3.106-3.19.883 0 1.642.064 1.863.094v2.16h-1.28c-1 0-1.195.48-1.195 1.18v1.54h2.39l-.31 2.42h-2.08V16h4.077c.488 0 .883-.395.883-.883V.883C16 .395 15.605 0 15.117 0" fill-rule="nonzero" /></svg>
                                </div>

                                <div className="content">
                                    <h1>Facebook</h1>
                                    <span>GihanTharangaBandara</span>
                                </div>

                                <svg className="arrow" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"> <g className="nc-icon-wrapper" fill="#444444"> <path d="M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z"></path> </g> </svg>
                            </a>

                            <a href={'/'} className={'facebook'} style={{ textAlign: 'left' }}>
                                <div class="icon">
                                    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M58.7 11.4C53.5 6.3 43.1 4 32 4S10.5 6.3 5.3 11.4a11.2 11.2 0 0 0-2 13.2c1.4 1.8 3.3 1.3 4.6 1.1L15 24a3.9 3.9 0 0 0 3-4.5c-.3-3 1.4-7.5 14-7.5s14.3 4.4 14 7.5 2.9 4.3 4 4.5 4.8 1.5 6.1 1.8 3.2.8 4.6-1.1a11.2 11.2 0 0 0-2-13.3z" fill-rule="nonzero" /><path data-name="layer1" d="M40 26.8V20a2 2 0 1 0-4 0v6.1h-8V20a2 2 0 0 0-4 0v6.8A22 22 0 0 0 8 48v12h48V48a22 22 0 0 0-16-21.2zM23 54h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm10 16h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm10 16h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4z" fill="#202020"></path></svg>
                                </div>

                                <div className="content">
                                    <h1>Contact No</h1>
                                    <span>071 978 1116</span>
                                </div>
                                <svg className="arrow" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"> <g className="nc-icon-wrapper" fill="#444444"> <path d="M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z"></path> </g> </svg>
                            </a>
                        </nav>
                    </div>
                </div>
            </div>
        </InfoContainer>
    )
}
export default ContactMe;

